import { render, staticRenderFns } from "./OffCanvasDetailsOstolasku.vue?vue&type=template&id=8acb43a4&scoped=true&"
import script from "./OffCanvasDetailsOstolasku.vue?vue&type=script&lang=js&"
export * from "./OffCanvasDetailsOstolasku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acb43a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8acb43a4')) {
      api.createRecord('8acb43a4', component.options)
    } else {
      api.reload('8acb43a4', component.options)
    }
    module.hot.accept("./OffCanvasDetailsOstolasku.vue?vue&type=template&id=8acb43a4&scoped=true&", function () {
      api.rerender('8acb43a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasDetailsOstolasku.vue"
export default component.exports